import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { CoachingPlanController } from 'presentation/app-sidebar/sidebar-coaching-plan/coaching-plan.controller';

import { SidebarPlanSection } from '../coaching-plan.models';

@Component({
	selector: 'spr-plan-phase',
	templateUrl: './plan-phase.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class: 'relative flex-auto',
	},
})
export class PlanPhaseComponent {
	public sections$: Observable<SidebarPlanSection[]>;

	constructor(coachingPlanController: CoachingPlanController) {
		this.sections$ = coachingPlanController.activePhase$.pipe(
			switchMap((phase) => phase.sections$),
			map((sections) =>
				sections.map(
					(section) =>
						({
							modules$: coachingPlanController.sectionModule$(section),
							instance: section,
						} as SidebarPlanSection)
				)
			)
		);
	}

	public trackBySection(index: number, section: SidebarPlanSection): string {
		return section.instance.id;
	}
}
